<template>

    <div>
        <center>
            <h2 class='title is-3'>Register an account</h2>
            <br/>
        </center>

        <div class="card" style='margin:auto;max-width:400px;'>
          <div class="card-content">
            <form action='/register' method='post'>
                <center>
                    <img class='image' src='@/assets/logo_tiny.png' />
                    <br/>
                </center>
                <div class="content">

                    <article v-if="serverError !== null" class="message is-danger">
                      <div class="message-body">
                        An error occurred while creating your account.<br/>
                        <ul>
                            <li>{{serverError}}</li>
                        </ul>
                      </div>
                    </article>

                    <b>What type of user are you?</b>
                    <div class="field">
                        <div class="control">
                            <label class="radio">
                                <input type="radio" value='student' required name="accountType"
                                    v-model="user.accountType"
                                    v-validate="'required'"
                                >
                                Student
                            </label>
                            <label class="radio">
                                <input type="radio" value='alumni' required name="accountType"
                                    v-model="user.accountType"
                                    v-validate="'required'"
                                >
                                Alumni
                            </label>
                        </div>
                        <p class="help is-danger">{{ errors.first('accountType') }}</p>
                    </div>

                    <div class="field">
                      <label for='first'>First name</label>
                      <p class="control">
                        <input required class='input fname' type='text' id='first' placeholder='Joe' name="firstName"
                            v-model='user.firstName'
                            v-validate="'required'"
                        />
                      </p>
                      <p class="help is-danger">{{ errors.first('firstName') }}</p>
                    </div>

                    <div class="field">
                      <label for='last'>Last name</label>
                      <p class="control">
                        <input required class='input lname' type='text' id='last' placeholder='Schmoe' name="lastName"
                            v-model='user.lastName'
                            v-validate="'required'"
                        />
                      </p>
                      <p class="help is-danger">{{ errors.first('lastName') }}</p>
                    </div>

                    <div class="field">
                      <label for='username'>Username</label>
                      <div class="control has-icons-left">
                        <input required class='input uname' type='text' id='username' placeholder='jschmoe' name="username"
                            v-model='user.username'
                            v-validate="'required'"
                        />
                        <span class='icon is-small is-left'>
                          <i class='fa fa-user'></i>
                        </span>
                      </div>
                      <p class="help is-danger">{{ errors.first('username') }}</p>
                    </div>

                    <div class="field">
                      <label for='email'>Email address</label>
                      <div class="control has-icons-left">
                        <input required class='input email' type='email' id='email' placeholder='user@email.com' name="email"
                            v-model='user.email'
                            v-validate="'required|email'"
                        />
                        <span class='icon is-small is-left'>
                          <i class='fa fa-envelope'></i>
                        </span>
                      </div>
                      <p class="help is-danger">{{ errors.first('email') }}</p>
                    </div>

                    <div class="field">
                      <label for='password'>Password</label>
                      <div class="control has-icons-left">
                        <input required class='input password' type='password' id='password' placeholder='password' name="password"
                            v-model='user.password'
                            v-validate="'required'"
                        />
                        <span class='icon is-small is-left'>
                          <i class='fa fa-lock'></i>
                        </span>
                      </div>
                      <p class="help is-danger">{{ errors.first('password') }}</p>
                    </div>

                    <div class="field">
                      <label for='confpassword'>Confirm password</label>
                      <div class="control has-icons-left">
                        <input required class='input confPassword' type='password' id='confpassword' placeholder='password' name="confirmPassword"
                            v-model='user.confirmPassword'
                            v-validate="'required'"
                        />
                        <span class='icon is-small is-left'>
                          <i class='fa fa-lock'></i>
                        </span>
                      </div>
                      <p class="help is-danger">{{ errors.first('confirmPassword') }}</p>
                    </div>

                    <div class="field">
                      <label for='confpassword'>University invite code</label>
                      <div class="control has-icons-left">
                        <input required class='input' type='text' id='inviteCode' placeholder='' name="inviteCode"
                            v-model='user.inviteCode'
                            v-validate="'required'"
                        />
                        <span class='icon is-small is-left'>
                          <i class='fa fa-lock'></i>
                        </span>
                      </div>
                      <p class="help is-danger">{{ errors.first('inviteCode') }}</p>
                    </div>

                    <p class='control'>
                        <input type='button' @click="registerAccount" id='submit-btn' class='button is-primary is-fullwidth' value='Create Account'/>
                    </p>
                </div>
            </form>
          </div>
        </div>
    </div>

</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
        serverError: null,
        passwordMismatch: false,
        user: {
            firstName: '',
            lastName: '',
            username: '',
            accountType: '', // `student` or `alumni`
            email: '',
            password: '',
            confirmPassword: '',
            inviteCode: ''
        }
    }
  },
  methods: {
    registerAccount: function() {
        this.$data.serverError = null;

        if(this.$data.user.password !== this.$data.user.confirmPassword) {
            // Do not continue if passwords do not match
            // UI will display an error to user
            this.$data.serverError = 'Passwords do not match';
            return false;
        }

        this.$validator.validate().then(isValid => {
            if(!isValid) {
                // Invalid form
            }
            else {
                this.$http.post(this.$hostname + '/user', this.$data.user).then(function(response) {
                    if(response.status === 200) {
                        // User is created
                        // TODO: log the user in and send them to the dashboard
                        alert('you successfully registered an account!');
                    }
                }).catch(function(error) {
                    this.$data.serverError = error.body.message;
                });
            }
        });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Register.vue